export type GaUserGroup = 'wavin' | 'jablotron' | 'normal';

export const isWavinOrOrbiaEmail = (email: string) => {
  const domain = email.trim().toLowerCase().split('@')[1];
  return domain === 'wavin.com' || domain === 'orbia.com';
};

export const isOrbiaEmail = (email: string) => {
  const domain = email.trim().toLowerCase().split('@')[1];
  return domain === 'orbia.com';
};

export function getGaUserGroup(email: string): GaUserGroup {
  if (isWavinOrOrbiaEmail(email)) {
    return 'wavin';
  }
  const domain = email.trim().toLowerCase().split('@')[1];
  if (domain === 'jablotron.cz') {
    return 'jablotron';
  }
  return 'normal';
}
